/**
 * The countdown's sound on your own turn (review 0013, decision 62; masayagel v1
 * decisions 250 and 294): quiet for the first half, a soft tick each second until the
 * ring turns red, then the recording at its own tempo. Pure.
 */

/** The ring is red for the last quarter of a turn (owner, 11 Sept); the pod draws it. */
export const LATE_SHARE = 0.25;

/**
 * The recording's length as the browser decodes it (8431 ms, measured 13 Sept 2026; the
 * masayagel note said 9.4 s): when the red band is longer, it covers the end (U1-B).
 */
export const BED_MS = 8_400;

export type Band = "quiet" | "tick" | "bed";

export function countdownBand(leftMs: number, budgetMs: number): Band {
  if (leftMs <= 0) return "quiet";
  if (leftMs <= Math.min(budgetMs * LATE_SHARE, BED_MS)) return "bed";
  return leftMs <= budgetMs / 2 ? "tick" : "quiet";
}

export interface CountdownState {
  bed: boolean;
  /** The second last ticked, so the 200 ms check does not tick the same second five times. */
  lastSecond: number | null;
}

export const COUNTDOWN_START: CountdownState = { bed: false, lastSecond: null };

/** One look at the clock: what to start or stop now, and what to remember. Pure. */
export function countdownStep(
  state: CountdownState,
  leftMs: number,
  budgetMs: number,
): { next: CountdownState; bed: "start" | "stop" | null; tick: boolean } {
  const band = countdownBand(leftMs, budgetMs);
  const inBed = band === "bed";
  const bed = inBed === state.bed ? null : inBed ? "start" : "stop";
  const second = Math.ceil(leftMs / 1_000);
  const tick = band === "tick" && second !== state.lastSecond;
  return { next: { bed: inBed, lastSecond: band === "tick" ? second : null }, bed, tick };
}
